import { BigNumber } from 'ethers'
import { useEffect, useState } from 'react'
import { useWallet } from './useWallet'

export function useGetBalance(): BigNumber | null {
	const { account, web3, chainId } = useWallet()

	const [balance, setBalance] = useState<BigNumber | null>(null)

	useEffect(() => {
		if (!web3 || !account) {
			setBalance(null)
			return
		}

		let ignore = false

		const listener = () => {
			web3.getBalance(account)
				.then((balance) => {
					if (ignore) {
						return
					}

					setBalance((currentBalance) => {
						if (currentBalance && currentBalance.eq(balance)) {
							return currentBalance
						}
						return balance
					})
				})
				.catch(() => {
					return BigNumber.from(0)
					// nothing
				})
		}

		listener()

		web3.on('block', listener)

		return () => {
			web3.off('block', listener)
			ignore = true
		}
	}, [web3, account, chainId])

	return balance
}
